import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export const useUsuarioConCedula = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useUsuarioConCedula debe usarse dentro de un AuthProvider');
  }
  
  return {
    usuarioConCedula: context.usuarioConCedula,
    setUsuarioConCedula: context.setUsuarioConCedula,
    isLoadingUsuario: context.isLoadingUsuario,
    errorUsuario: context.errorUsuario,
    refreshUsuarioConCedula: context.refreshUsuarioConCedula,
  };
}; 